import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-08d33c1c")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Save Template", -1)
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "save-template" }, " Template Name ", -1)
const _hoisted_5 = {
  key: 1,
  id: "loading-wrap"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  version: "1.1",
  id: "loader-1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "40px",
  height: "40px",
  viewBox: "0 0 50 50",
  style: {"enable-background":"new 0 0 50 50"},
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#ff6c00",
    d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeType: "xml",
      attributeName: "transform",
      type: "rotate",
      from: "0 25 25",
      to: "360 25 25",
      dur: "0.6s",
      repeatCount: "indefinite"
    })
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleModal && _ctx.handleModal(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, {
        class: "btn-icon",
        icon: "save",
        "aria-hidden": "true"
      }),
      _hoisted_1
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([_ctx.fadeTransition, "modal"])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["modal-body", _ctx.bounceTransition])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
                _createElementVNode("div", {
                  style: {"height":"30px","width":"30px"},
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleModal && _ctx.handleModal(...args)))
                }, [
                  _createVNode(_component_CloseSVG, { propId: 'save-template-close' })
                ])
              ]),
              _createElementVNode("form", {
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _withDirectives(_createElementVNode("input", {
                    id: "save-template",
                    class: "form-input",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.templateName = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.templateName]
                  ])
                ]),
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      "aria-label": "Submit save template",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSaveTemplate && _ctx.handleSaveTemplate(...args))),
                      class: "modal-select-btn",
                      type: "submit"
                    }, " Save "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              ], 32)
            ], 2)
          ], 2))
        : _createCommentVNode("", true)
    ]))
  ]))
}